/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetUsageFee200ResponseBillsInner
 */
export interface GetUsageFee200ResponseBillsInner {
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200ResponseBillsInner
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200ResponseBillsInner
     */
    'bankAccountActivityId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200ResponseBillsInner
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200ResponseBillsInner
     */
    'latestStatus': GetUsageFee200ResponseBillsInnerLatestStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200ResponseBillsInner
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200ResponseBillsInner
     */
    'appliedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200ResponseBillsInner
     */
    'transferDate': string;
}

export const GetUsageFee200ResponseBillsInnerLatestStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type GetUsageFee200ResponseBillsInnerLatestStatusEnum = typeof GetUsageFee200ResponseBillsInnerLatestStatusEnum[keyof typeof GetUsageFee200ResponseBillsInnerLatestStatusEnum];


